import React from "react";
import { ChevronsUpDown, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";

export default function GroupMultiSelect({ subs = [], value = [], onChange, allLabel = "Entire team", showCounts = false, testId = "group-multi-select" }) {
  const selected = value || [];
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  const label =
    selected.length === 0
      ? allLabel
      : selected.length === 1
      ? subs.find((s) => s.id === selected[0])?.name || "1 group"
      : `${selected.length} groups selected`;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
        >
          <span className={selected.length ? "text-slate-900" : "text-slate-500"}>{label}</span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-1" align="start">
        <button
          type="button"
          onClick={() => onChange([])}
          data-testid={`${testId}-all`}
          className="flex w-full items-center justify-between rounded-sm px-2 py-2 text-sm hover:bg-slate-100"
        >
          <span className="font-medium">{allLabel}</span>
          {selected.length === 0 && <Check className="h-4 w-4 text-slate-900" />}
        </button>
        <div className="my-1 h-px bg-slate-100" />
        <div className="max-h-60 overflow-y-auto">
          {subs.map((s) => (
            <label
              key={s.id}
              data-testid={`${testId}-option-${s.id}`}
              className="flex cursor-pointer items-center gap-2 rounded-sm px-2 py-2 text-sm hover:bg-slate-100"
            >
              <Checkbox checked={selected.includes(s.id)} onCheckedChange={() => toggle(s.id)} data-testid={`${testId}-checkbox-${s.id}`} />
              <span className="flex-1">{s.name}</span>
              {showCounts && <span className="text-xs text-slate-400">{s.active_count ?? s.member_count ?? 0}</span>}
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
